var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_842_1760)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39,
    r: 39,
    fill: "#43EC9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.875 49.6364H46.75V47.6663C46.7465 46.99 46.6325 46.3193 46.413 45.6835C46.4007 45.6488 46.3878 45.6166 46.3726 45.5836C46.1904 45.0617 45.9387 44.5696 45.625 44.122L44.0501 41.9153C43.6131 41.3006 43.3764 40.5543 43.375 39.7871V38.5937C43.3776 37.6541 43.7326 36.7534 44.3632 36.0869L45.1026 35.3102C45.9617 34.4029 46.5135 33.2244 46.6734 31.9558C46.674 31.9393 46.6824 31.9256 46.6824 31.909L46.6793 31.8928C46.7184 31.6412 46.742 31.3871 46.75 31.1323V28.3636H47.875C48.1734 28.3636 48.4595 28.2391 48.6705 28.0175C48.8815 27.7959 49 27.4953 49 27.1818C49 26.8684 48.8815 26.5678 48.6705 26.3461C48.4595 26.1245 48.1734 26 47.875 26H32.125C31.8266 26 31.5405 26.1245 31.3295 26.3461C31.1185 26.5678 31 26.8684 31 27.1818C31 27.4953 31.1185 27.7959 31.3295 28.0175C31.5405 28.2391 31.8266 28.3636 32.125 28.3636H33.25V31.1323C33.258 31.3871 33.2816 31.6412 33.3207 31.8928L33.3176 31.9091C33.3176 31.9256 33.3259 31.9394 33.3266 31.9558C33.4865 33.2245 34.0383 34.4029 34.8974 35.3103L35.6368 36.087C36.2673 36.7534 36.6224 37.6541 36.625 38.5937V39.7871C36.6235 40.5542 36.387 41.3004 35.9504 41.9153L34.3744 44.1219C34.0608 44.5698 33.8092 45.062 33.627 45.584C33.6121 45.6168 33.5992 45.6486 33.5871 45.6829C33.3675 46.3189 33.2535 46.9898 33.25 47.6663V49.6364H32.125C31.8266 49.6364 31.5405 49.7609 31.3295 49.9825C31.1185 50.2041 31 50.5047 31 50.8182C31 51.1316 31.1185 51.4322 31.3295 51.6539C31.5405 51.8755 31.8266 52 32.125 52H47.875C48.1734 52 48.4595 51.8755 48.6705 51.6539C48.8815 51.4322 49 51.1316 49 50.8182C49 50.5047 48.8815 50.2041 48.6705 49.9825C48.4595 49.7609 48.1734 49.6364 47.875 49.6364ZM35.5 30.7273V28.3636H44.5V30.7273H35.5ZM36.4882 33.6391C36.3297 33.4718 36.1876 33.2882 36.0642 33.0909H43.9358C43.8123 33.2882 43.6703 33.4718 43.5118 33.6391L42.7724 34.4158C41.8948 35.3323 41.3322 36.5291 41.1728 37.8182H38.8272C38.6678 36.5291 38.1051 35.3322 37.2276 34.4157L36.4882 33.6391ZM37.7505 43.3325C38.4015 42.4163 38.7875 41.3224 38.8624 40.1818H41.1376C41.2124 41.3225 41.5986 42.4164 42.25 43.3325L43.3751 44.9091H36.6246L37.7505 43.3325ZM44.5 49.6364H35.5V47.6663C35.5031 47.5346 35.5134 47.4032 35.5306 47.2727H44.4694C44.4866 47.4032 44.4969 47.5346 44.5 47.6663V49.6364Z",
    fill: "#000B29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_842_1760",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_842_1760"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_842_1760",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentRequestIcon);
export default __webpack_public_path__ + "static/media/sentRequestIcon.21abfc391345ee6d2c14186087f3ceac.svg";
export { ForwardRef as ReactComponent };